import { lazy } from 'react';
import AuthRoles from '@/app/auth/authRoles';

const MessageTemplatesPage = lazy(() => import('./MessageTemplatesPage'));

const MessageTemplatesConfig = {
  settings: {
    layout: {},
  },
  auth: AuthRoles.MessagingConfig,
  routes: [
    {
      path: 'message-templates',
      element: <MessageTemplatesPage />,
    },
  ],
};

export default MessageTemplatesConfig;
